import { useCallback } from 'react';
import Text from 'fe-design-base/atoms/Text';
import { List } from 'immutable';
import { omit } from 'lodash';

import { timesheetsRoutes } from 'selectors/session';

import { cxHelpers } from 'util/className';
import { trackUxEvent } from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
} from 'util/tracking_constants';

import withNavItemActive from '../../hocs/withNavItemActive';
import withNavItemData from '../../hocs/withNavItemData';
import NavItem from '../NavItem';
import NavItemWithSubNav from '../NavItemWithSubNav';

const { cx } = cxHelpers('TimesheetsNavItem');

type TimesheetsNavItemProps = {
  url: string;
  currentRoute?: string;
  active: boolean;
  hidden?: boolean;
  whiteText?: boolean;
  menuItems?: List<any>;
  [key: string]: any; // For other props passed through HOCs
};

const TimesheetsNavItem = (props: TimesheetsNavItemProps) => {
  const { url, currentRoute } = props;
  const filteredProps = omit(props, 'whiteText');

  const trackEvent = useCallback(() => {
    trackUxEvent({
      productArea: PRODUCT_AREAS.NAVIGATION,
      eventCategory: EVENT_CATEGORIES.NAV,
      eventAction: EVENT_ACTIONS.TIMESHEETS_TAB_CLICKED,
    });
  }, []);

  const Component = props.menuItems ? NavItemWithSubNav : NavItem;

  return (
    <Component
      currentRoute={currentRoute}
      {...filteredProps}
      href={url}
      onClick={trackEvent}
      className={cx()}
    >
      <Text variant="bodySm" i18n="nav_links.timesheets.top_level" />
    </Component>
  );
};

export default withNavItemActive(timesheetsRoutes)(
  withNavItemData('timesheets')(TimesheetsNavItem)
);
